import Main from './index.vue'

export default [
  { path: '/review', component: Main, meta: { auth: true } }
]